import type {
	CoreApiUuidModel,
	PaymentProvider,
	PriceCurrency,
} from '@lqa-frontend/api-services';

export interface MyLQAPlanCollection extends CoreApiUuidModel {
	name: string;
	headline: string | null;
	features: string[];
}

export type MyLQATierState = 'draft' | 'active' | 'archived';
export const myLQATierStateValues = ['draft', 'active', 'archived'] as const;

export type MyLQATierType = 'standard' | 'custom' | 'trial';
export const myLQATierTypeValues = ['standard', 'custom', 'trial'] as const;

export interface MyLQATierCollection extends CoreApiUuidModel {
	custom: boolean;
	tierType: MyLQATierType;
	name: string;
	state: MyLQATierState;
	externalIds: Record<PaymentProvider, string>;
	plan?: MyLQAPlanCollection;
	regularVariant?: MyLQATierVariantCollection | null;
}

export interface MyLQATierDetail extends MyLQATierCollection {
	regularVariant?: MyLQATierVariantCollection | null;
}

export type MyLQATierVariantState = 'draft' | 'active' | 'archived';
export const myLQATierVariantStateValues = [
	'draft',
	'active',
	'archived',
] as const;

export interface MyLQATierVariantCollection extends CoreApiUuidModel {
	createdBy: { id: number; name: string };
	name: string;
	pricingPerMonth: Record<PriceCurrency, number>;
	includedSeats: number;
	state: MyLQATierVariantState;
	externalIds: Record<PaymentProvider, string>;
	tier: MyLQATierCollection;
	hotel?: {
		id: number;
		name: string;
	};
	brand?: {
		id: number;
		name: string;
	};
}

export type MyLQATierVariantDetail = MyLQATierVariantCollection;
